export default class AuthorsLetters {

  constructor(debug = false) {

    this.debug = debug;

    if (this.debug) console.log('AuthorsLetters - init');

    if (this.setVars()) {
      if (this.debug) console.log('AuthorsLetters - vars init done');
      this.setEvents();
    }
  }

  setVars()
  {
    this.offset           = 0;
    this.eventCount       = 0;
    this.eventWidth       = 0;
    this.eventWindowWidth = 0;
    this.offsetMax        = 0;
    this.textDirection    = getComputedStyle(document.querySelector('html')).direction;

    this.authorsLettersEl = document.querySelector('.jsAuthorsLetters');
    if (!this.authorsLettersEl) return false;

    this.eventWindowEl = document.querySelector('[data-authors-letters-window]');
    if (!this.eventWindowEl) return false;

    this.eventAuthorsLettersEl = document.querySelector('[data-authors-letters-letter]');
    if (!this.eventAuthorsLettersEl) return false;

    this.authorsLettersEventArr = this.authorsLettersEl.querySelectorAll(
      '[data-authors-letters-event]'
    );
    if (!this.authorsLettersEventArr.length) return false;

    this.authorsLettersButtonArr = this.authorsLettersEl.querySelectorAll(
      '[data-authors-letters-button]'
    );
    if (!this.authorsLettersButtonArr.length) return false;

    this.calcEventVars();

    return true;
  }

  setEvents()
  {
    if (this.debug) console.log('AuthorsLetters - setting events');

    this.authorsLettersButtonArr.forEach((el) => {
      el.addEventListener('click', (e) => {
        e.preventDefault();
        this.buttonClick(e.target);
      });
    });

    window.addEventListener('resize', () => {
      this.calcEventVars();
      this.recalculateOffsetRight();
    });

    // Scroll active letter into view on page load
    this.scrollActiveIntoView();
  }

  scrollActiveIntoView()
  {
    const activeLetter = this.eventAuthorsLettersEl.querySelector('.active');
    if (activeLetter) {
      activeLetter.scrollIntoView({
        behavior: 'instant',
        block: 'nearest',
        inline: 'center'
      });
      if (this.debug) console.log('AuthorsLetters - scrolled active letter into view');
    }
  }

  calcEventVars()
  {
    this.eventCount       = this.authorsLettersEventArr.length;
    this.eventWidth       = this.authorsLettersEventArr[0].offsetWidth;
    this.eventWindowWidth = this.eventWindowEl.offsetWidth;
    this.offsetMax        = Math.max(
      this.eventCount - Math.ceil((this.eventWindowWidth / this.eventWidth) - 2), 0
    ); // 2 - we need space for left/right arrows

    if (this.debug) console.log('eventWindowWidth / eventWidth', this.eventWindowWidth, this.eventWidth);
    if (this.debug) console.log('eventCount / offsetMax', this.eventCount, this.offsetMax);
  }

  buttonClick(el)
  {
    if (this.debug) console.log('AuthorsLetters - offset before', this.offset);

    const direction = el.getAttribute('data-authors-letters-button');
    const amount = 100;

    switch (direction) {
    case 'left':
      this.recalculateOffsetLeft();
      this.eventAuthorsLettersEl.scrollTo({
        left: this.eventAuthorsLettersEl.scrollLeft - amount,
        behavior: 'smooth'
      });
      break;

    case 'right':
      this.recalculateOffsetRight();
      this.eventAuthorsLettersEl.scrollTo({
        left: this.eventAuthorsLettersEl.scrollLeft + amount,
        behavior: 'smooth'
      });
      break;

    default:
      if (this.debug) console.log('AuthorsLetters - button click UNSUPPORTED');
    }

  }

  recalculateOffsetLeft()
  {
    if (this.debug) console.log('AuthorsLetters - moving left', this.offset);
    this.offset = (this.offset > 0) ? (this.offset - 1) : 0;
  }

  recalculateOffsetRight()
  {
    if (this.debug) console.log('AuthorsLetters - moving right', this.offset, this.offsetMax, (this.offset <= this.offsetMax));
    this.offset = this.offset <= this.offsetMax ? (this.offset + 1) : this.offset;
  }
}
